import BudgetControlCardFilter from "./BudgetControlCardFilter"
import BudgetControlCardItem from "./BudgetControlCardItem"


const BudgetControlCard = () => {
  return (
    <>
    <BudgetControlCardFilter/>
    <BudgetControlCardItem/>
    </>
  )
}

export default BudgetControlCard